import '@/styles/index.css';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { BrowserRouter } from 'react-router-dom';
import { DbProvider } from './database/provider/DbProvider.tsx';
import { PGlite } from '@electric-sql/pglite';
import { drizzle } from 'drizzle-orm/pglite';
import { getLastMigration } from './database/migrations.ts';
import journal from "../drizzle/meta/_journal.json";
import * as Sentry from "@sentry/react";
import { compareVersions, migrateToLatest } from './utils.ts';
import packageJson from '../package.json';



export const client = new PGlite('idb://invoices');
export const db = drizzle(client);

Sentry.init({
  dsn: 'https://d5c026b8637b5024323881d3298ab7fe@o4509078888644608.ingest.de.sentry.io/4509230809940048',
  beforeSend: async (event, hint) => {
    if (['localhost', '127.0.0.1'].includes(window.location.hostname)) return null;
    const lastMigration = await getLastMigration(db);
    hint.attachments = [
      { filename: "lastMigration.txt", data: JSON.stringify(lastMigration) },
    ]
    return event;
  },
  integrations: [Sentry.breadcrumbsIntegration({
    console: true,
    dom: true,
    fetch: true,
    history: true
  }), Sentry.captureConsoleIntegration({
    levels: ["error"]
  }),
  Sentry.contextLinesIntegration()],
  attachStacktrace: true,
  tracesSampleRate: 1.0,
  tracePropagationTargets: [/^https:/],
});

async function start() {

  let version = localStorage.getItem("version");
  const actualVersion = packageJson.version;
  if (!version) {
    await migrateToLatest(db, journal);
    localStorage.setItem("version", actualVersion);
    version = actualVersion;
  }

  const isNewVersionAvailable = compareVersions(actualVersion, version);
  createRoot(document.getElementById('root')!).render(
    <DbProvider>
      <BrowserRouter>
        <App updateAvailable={isNewVersionAvailable === 1} />
      </BrowserRouter>
    </DbProvider>
  )
}

start().catch(async (err) => {
  Sentry.captureException(err);
})